import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses, accessNested } from 'utils/utils';
import Button from 'components/bolt/button/button';
import s from 'components/bolt/videos/playlist/playlistItem.sss';

export default class VideosPlaylistItem extends Component {
	render(props) {
		const { item, onClick, activeVideo } = props;
		const thumbStyle = {
			backgroundImage: 'url("' + item.thumbSrc + '")'
		};

		let faded = (activeVideo && item) && (activeVideo.key !== item.key);

		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');
		const isRTL = fontStyles.textDirection === 'rtl';

		return (
			<Button class={joinClasses({ s, container: true, faded })} trigger={onClick}>
				<div class={s.thumbBtn}>
					<div class={s.thumb} style={thumbStyle} role="img" ariaLabel={item.thumbAria || item.name} />
				</div>
				<div class={joinClasses(s.name, fontStyles.videoTitles, isRTL && s.rtlName)}>{item.name}</div>
			</Button>
		);
	}
}
